import React from 'react';
import { IBuyboxResources } from '../../definition-extensions/buybox.ext.props.autogenerated';

export default function(resources: IBuyboxResources) {
    const { iHereByText, underStoodText, infoProvidedAccurate, responsiblePayingAppeal } = resources;
    return (
        <div className='cui alert-banner inline caution'>
            <div className='alert-body'>
                <span className='alert-icon cicon-exclamation-circle'></span>
                <h2 className='alert-title'>{iHereByText}</h2>
                <ul className='list-style-dot'>
                    <li>
                        <strong>{underStoodText}</strong>
                    </li>
                    <li>
                        <strong>{infoProvidedAccurate}</strong>
                    </li>
                    <li>
                        <strong>{responsiblePayingAppeal}</strong>
                    </li>
                </ul>
            </div>
        </div>
    );
}
